import React, { ReactElement, useCallback, useState } from 'react';
import { Modal } from '@components/common/modal/modal';
import { FCPStatus } from '@components/common/fcp-status/fcpStatus';
import { overlayRemoveFadeAction } from '@components/common/sort';
import { ContractorFpcDetails } from './fpcDetails';
import { IFpcDetailsSectionProps } from '.';

export const FpcDetailsSection: React.FC<IFpcDetailsSectionProps> = ({
	fpcDetails,
	membershipNo,
	subContractor,
	modeType,
}): ReactElement => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [hasModalOpened, setHasModalOpened] = useState(false);

	const closeEndUserModal = useCallback((): void => {
		overlayRemoveFadeAction(() => {});
		setIsModalOpen(false);
	}, []);

	const handleFpcDetailsdetailsBtnClick = (): void => {
		if (modeType === 'component') {
			if (!hasModalOpened) setHasModalOpened(true);
			setIsModalOpen(true);
		}
	};

	return (
		<section className="product-usage-wrapper">
			<div className="container">
				<>
					<FCPStatus
						track={fpcDetails?.track ?? false}
						pwg_ytd={fpcDetails?.pwg_ytd ?? 0}
						balance={fpcDetails?.balance ?? 0}
						subContractor={subContractor}
						openModal={handleFpcDetailsdetailsBtnClick}
						label="YTD Achieved"
					/>
					{modeType === 'page' && (
						<ContractorFpcDetails title="Sub-Contractor FPC Details" membershipNo={membershipNo} />
					)}
				</>
			</div>
			{modeType === 'component' && hasModalOpened && (
				<Modal
					modalOpen={isModalOpen}
					modalId="closeLeads"
					onModalClose={closeEndUserModal}
					className="dialog-sm close-site-popup dialog-conform"
					modalTitle="Sub-Contractor FPC Details"
				>
					<ContractorFpcDetails membershipNo={membershipNo} />
				</Modal>
			)}
		</section>
	);
};
